import React, { Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import loadable from '@loadable/component';
import FormStore from 'lib/stores/formStore';
import ModalStore, { closeModal } from 'lib/stores/modalStore';
import LoaderStore, { reset } from 'lib/stores/loaderStore';
import Modal from 'lib/components/Modal';

const RoomPhotoForm = loadable(() => import('lib/components/Forms/Host/RoomPhoto'));

const RoomPhotoModal = () => {
  const { open, data: { photo } } = ModalStore.useState(state => state.roomPhotoModal);
  const editingPhoto = Object.keys(photo).length > 0;

  const onCloseRoomPhotoModal = () => {
    FormStore.update(state => {
      state.room = {};
      state.room_photo = {};
    });
    ModalStore.update(state => closeModal(state, 'roomPhoto', { photo: {} }));
    LoaderStore.update(reset);
  };

  return (
    <Modal
      title={editingPhoto ? 'Edit Photo' : 'Add Photo'}
      onClose={onCloseRoomPhotoModal}
      acceptMessage="Submit"
      open={open}
      id="roomPhotoModal"
    >
      <ErrorBoundary fallback={<div>Error loading form</div>}>
        <Suspense fallback={<div>Loading form...</div>}>
          <RoomPhotoForm
            existingPhoto={photo}
            onAfterSubmit={onCloseRoomPhotoModal}
          />
        </Suspense>
      </ErrorBoundary>
    </Modal>
  );
};

export default RoomPhotoModal;
